import React from 'react';
import { Card, Avatar, Typography, Button, Divider } from 'antd';
import { MailOutlined, CalendarOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

interface CustomerSuccessManagerProps {
	name: string;
	avatarUrl: string;
	description: string;
	email: string;
	calendlyLink: string;
	className?: string;
}

const CustomerSuccessManager: React.FC<CustomerSuccessManagerProps> = ({
	name,
	avatarUrl,
	description,
	email,
	calendlyLink,
	...props
}) => {
	return (
		<Card className={'w-full rounded-xl ' + props.className}>
			<div className="flex justify-center items-center mb-4">
				<h3 className="text-lg font-semibold text-gray-800 m-0">CUSTOMER SUCCESS MANAGER</h3>
			</div>

			<div className="mb-6 flex flex-col items-center gap-2">
				<Avatar src={avatarUrl} size={96} className="border-2 border-gray-200" />
				<Title level={3} className="m-0">
					{name}
				</Title>
			</div>

			<Paragraph className="text-gray-600 mb-6 text-center">{description}</Paragraph>

			<Divider className="my-4" />

			<Link
				className="flex items-center gap-4 mb-4 hover:bg-gray-50 px-3 py-1 rounded-lg cursor-pointer"
				to={`mailto:${email}`}
			>
				<div className="bg-gray-100 p-2 rounded-md">
					<MailOutlined className="text-gray-500" />
				</div>
				<div>
					<Text type="secondary" className="block">
						Email
					</Text>
					<Text className="text-gray-600">{email}</Text>
				</div>
			</Link>

			<Button
				type="primary"
				icon={<CalendarOutlined />}
				className="w-full flex items-center justify-center h-12"
				onClick={() => window.open(calendlyLink, '_blank')}
			>
				Schedule a call
			</Button>
		</Card>
	);
};

export default CustomerSuccessManager;
